import api from "./api";

export const getTemplate = async () => {
  return await api.get("/template/templates");
};

export const updateTemplate = async (data) => {
  return await api.put("/template/templates", data);
};

export const addTemplate = async (data) => {
  return await api.post("/template/templates", data);
};
